// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ChevronsUpDown from "@insite/mobius/Icons/ChevronsUpDown";
import Search from "@insite/mobius/Icons/Search";
import ShoppingCart from "@insite/mobius/Icons/ShoppingCart";
import X from "@insite/mobius/Icons/X";
import { PaginationStyle } from "@insite/mobius/Pagination";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { myListsDetailsOptionsStyles } from "@rpsc/Overrides/Widgets/MyListsDetails/MyListsDetailsOptions";
import IconSearch from "@rpsc/XDL/Icons/IconSearch";
import { color, createLinkIconStyles, hideElementOnPrint, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

myListsDetailsOptionsStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        ${xScreen("lte", "md")} {
            gap: 20px;
        }
        margin-bottom: 4px;
        ${hideElementOnPrint}
    `,
};

myListsDetailsOptionsStyles.topSectionWrapper = {
    css: css`
        display: flex;
        column-gap: 22px;
        row-gap: 12px;
        width: 100%;
        ${xScreen("lte", "md")} {
            flex-direction: column-reverse;
        }
        ${PaginationStyle} {
            margin: 0;
        }
    `,
};

myListsDetailsOptionsStyles.leftSectionWrapper = {
    css: css`
        display: flex;
        width: 100%;
        column-gap: 32px;
        row-gap: 12px;

        ${xScreen("lte", "sm")} {
            padding-top: 12px;
            flex-direction: column;
        }
    `,
};

myListsDetailsOptionsStyles.addDeleteWrapper = {
    css: css`
        display: flex;
        column-gap: 32px;
        row-gap: 12px;
    `,
};

myListsDetailsOptionsStyles.rightSectionWrapper = {
    css: css`
        display: flex;
        align-items: flex-end;
        width: 100%;
        column-gap: 22px;
        row-gap: 12px;
        ${xScreen("lte", "sm")} {
            border-bottom: 1px solid ${color("common.border")};
            padding-bottom: 12px;
            flex-direction: column;
        }
    `,
};

myListsDetailsOptionsStyles.search = {
    mergeCss: true,
    sizeVariant: "small",
    iconProps: {
        src: IconSearch,
        size: 15,
        color: "common.ui7",
    },
    cssOverrides: {
        formField: css`
            &:has(input:hover) {
                ${IconWrapper} {
                    color: ${color("common.ui8")};
                }
            }
        `,
    },
};

myListsDetailsOptionsStyles.sortBySelect = {
    mergeCss: true,
    sizeVariant: "small",
    cssOverrides: {
        formInputWrapper: css`
            width: 263px;
            ${xScreen("lte", "md")} {
                width: 100%;
            }
        `,
        formField: css`
            &&& {
                align-items: center;
            }
            ${xScreen("lte", "sm")} {
                align-items: flex-start;
                flex-direction: row;
            }
            ${TypographyStyle} {
                padding-top: 0;
                ${xScreen("lte", "sm")} {
                    width: 100px;
                }
            }
        `,
    },
};

myListsDetailsOptionsStyles.editSortOrder = {
    css: css`
        cursor: pointer;
    `,
};

myListsDetailsOptionsStyles.addSelectedToCartLink = {
    ...createLinkIconStyles(ShoppingCart, {
        icon: {
            iconProps: {
                size: 12,
                css: css`
                    margin-right: 6px;
                `,
            },
        },
        css: css`
            display: flex;
            justify-content: center;
            &:disabled {
                opacity: 0.33;
            }
        `,
    }),
};
myListsDetailsOptionsStyles.deleteSelectedLink = {
    ...createLinkIconStyles(X, {
        icon: {
            iconProps: {
                size: 12,
                css: css`
                    margin-right: 6px;
                `,
            },
        },
        css: css`
            display: flex;
            justify-content: center;
            &:disabled {
                opacity: 0.33;
            }
        `,
    }),
};
myListsDetailsOptionsStyles.editSortOrderLink = {
    ...createLinkIconStyles(ChevronsUpDown, {
        icon: {
            iconProps: {
                size: 12,
                css: css`
                    margin-right: 6px;
                `,
            },
        },
        css: css`
            display: flex;
            justify-content: center;
        `,
    }),
};
